module.exports = __webpack_public_path__ + "img/logo-dashboard.a2acade8.png";